import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { ComboBox, Switch, Text } from '@reveni-io/reveni-ui'

import { errorTypes } from '@/configuration/pages/ConfigurationPage/ReturnPolicy/PolicyRulesConfiguration/PolicyRuleDetailConfiguration/constants'

import { methodsWithExtraCredit, refundMethodOptions } from './constants'
import * as Styles from './styles'

const ForceRefundMethodConfig = ({ config, onChangeConfig, disabled, errors = [] }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const hasRefundMethodError = errors.some(e => e.type === errorTypes.actionRefundMethodEmpty)
  const showExtraCreditSwitch = methodsWithExtraCredit.includes(config.refund_method)

  const translatedOptions = refundMethodOptions.map(option => ({
    ...option,
    label: t(option.labelKey),
  }))

  const handleChangeRefundMethod = e => {
    const newMethod = e.target.value
    const newConfig = { refund_method: newMethod }

    if (!methodsWithExtraCredit.includes(newMethod)) {
      newConfig.ignore_extra = false
    }

    onChangeConfig(newConfig)
  }

  return (
    <Styles.Container>
      <Text type="bodyMBold">{t('Método de reembolso')}</Text>
      <ComboBox
        label={t('Método de reembolso')}
        menuItems={translatedOptions}
        handleChange={handleChangeRefundMethod}
        value={config.refund_method || ''}
        fullWidth
        disabled={disabled}
        backgroundColor={theme.colors.background.primary}
        error={hasRefundMethodError}
        helperText={hasRefundMethodError ? t('Este campo es obligatorio') : ' '}
      />
      {showExtraCreditSwitch && (
        <Switch
          label={t('Incluir crédito adicional')}
          checked={!config.ignore_extra}
          onChange={e => onChangeConfig({ ignore_extra: !e.target.checked })}
          disabled={disabled}
        />
      )}
    </Styles.Container>
  )
}

export default ForceRefundMethodConfig
